import { reactive, toRef } from "vue";
import AudioManager from "@webgl/core/audio/AudioManager";

export default function useAudioManager() {
  const manager = reactive(AudioManager);
  const muted = toRef(manager, "muted");

  return { muted };
}
